export var Strategy = {
  Absloute: 'absolute',
  Fixed: 'fixed'
};